<template>
  <v-menu
    v-model="menu" :disabled="disabled"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field 
        v-model="formattedDate" :label="label"
      
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        :rules="rules"
        ref="dateField"
      ></v-text-field>
    </template>

    <v-date-picker
      v-model="selectedDate"
      @input="validateDate"
      locale="tr"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: String, // v-model desteği
    rules: {
      type: Array,
      default: () => [
       
      ],
      
    },
    label: {
      type: String,
      default: "Tarih Seç" // Varsayılan etiket
    },
    disabled:{
        type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      selectedDate: this.value || null
    };
  },
  computed: {
    formattedDate() {
      return this.selectedDate ? this.formatDate(this.selectedDate) : "";
    }
  },
  watch: {
    value(newVal) {
      this.selectedDate = newVal;
    }
  },
  methods: {
    validateDate(date) {
      this.selectedDate = date;
      this.$emit("input", date);
      this.$refs.dateField.validate(); // Doğrulama çalıştır
      this.menu = false;
    },
    formatDate(date) {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date).toLocaleDateString("en-ZA", options);
    }
  }
};
</script>
